import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { DeviceInterface } from '../../store/callrecorder/devicesSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.devicePath(value.id)
  };
}

export const devicesEntity = new schema.Entity(
  'devices',
  {},
  {
    processStrategy
  }
);

export const deviceEntity = new schema.Entity(
  'device',
  {},
  {
    processStrategy
  }
);

const fetchDevicesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      devices: { [key: string]: DeviceInterface };
    }
  >(response.data.devices, [devicesEntity]);

  return {
    devices: normalized.entities?.devices || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { device: DeviceInterface; }
  >(response.data.device, deviceEntity);
  return normalized.entities;
}

export const fetchDevices = createAsyncThunk(
  `${PREFIX}_devices/fetchDevices`,
  async (params: object = {}) => fetchDevicesCollection('/onesky/devices', params)
);

export const fetchDevice = createAsyncThunk(
  `${PREFIX}_devices/fetchDevice`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/devices/${id}`);
    return normalizeInstance(response);
  }
);
